export const images = {
  logo: require("../assets/png/logo.png"),
  initialBackground: require("../assets/png/initial_background.png"),
  member: require("../assets/png/member.png"),
  desktopLandingBackground: require("../assets/png/desktop_landing_background.png"),
  errorBackground: require("../assets/png/bogey.png"),
  placeholder: require("../assets/png/placeholder.png"),
  updatePrompt: require("../assets/png/tee-off.png"),
  coursePlaceholder1: require("../assets/png/course_placeholder_1.png"),
  coursePlaceholder2: require("../assets/png/course_placeholder_2.png"),
  coursePlaceholder3: require("../assets/png/course_placeholder_3.png"),
  coursePlaceholder4: require("../assets/png/course_placeholder_4.png"),
  coursePlaceholder5: require("../assets/png/course_placeholder_5.png"),
};

export type Images = typeof images;
export type Image = keyof typeof images;
